import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Liste des partenaires avec leurs logos
const partners = [
  { name: "Partenaire 1", logo: "../assets/images/patners/image1.png" },
  { name: "Partenaire 2", logo: "../assets/images/patners/image2.png" },
  { name: "Partenaire 3", logo: "../assets/images/patners/image3.png" },
  { name: "Partenaire 4", logo: "../assets/images/patners/image4.png" },
  { name: "Partenaire 5", logo: "../assets/images/patners/image5.png" },
  { name: "Partenaire 6", logo: "../assets/images/patners/image6.png" },
  { name: "Partenaire 7", logo: "../assets/images/patners/image7.png" },
  { name: "Partenaire 8", logo: "../assets/images/patners/image8.png" },
  { name: "Partenaire 9", logo: "../assets/images/patners/image9.png" },
  { name: "Partenaire 10", logo: "../assets/images/patners/image10.png" },
  { name: "Partenaire 11", logo: "../assets/images/patners/image11.png" },
  { name: "Partenaire 12", logo: "../assets/images/patners/image12.png" },
  { name: "Partenaire 13", logo: "../assets/images/patners/image13.png" },
  { name: "Partenaire 14", logo: "../assets/images/patners/image14.png" },
  { name: "Partenaire 15", logo: "../assets/images/patners/image15.png" },
  { name: "Partenaire 16", logo: "../assets/images/patners/image16.png" },
  
];

const PartnersCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <Section>
      <Title>Nos <span>Partenaires</span></Title>
      <SliderContainer>
        <Slider {...settings}>
          {partners.map((partner, index) => (
            <Slide key={index}>
              <Logo src={partner.logo} alt={partner.name} />
            </Slide>
          ))}
        </Slider>
      </SliderContainer>
    </Section>
  );
};

export default PartnersCarousel;


const Section = styled.section`
  padding: 60px 10%;
  text-align: center;
 
`;

const Title = styled.h2`
  font-size: 2.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  span {
    color: #e60000;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const SliderContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  overflow: hidden;
`;

const Slide = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;

const Logo = styled.img`
  width: 150px;
  height: auto;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;
